<template>
  <svg version="1.1" class="pto-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    width="30px" height="30px" viewBox="0 0 18.698 19.533" style="enable-background:new 0 0 18.698 19.533;"
    xml:space="preserve">
    <path d="M13.483,9.544l-1.93,1.93l1.48,5.08l-0.43,0.43l-2.54-4.02l-1.97,1.97l-0.29,0.15l0.32,1.87l-0.41,0.42
      l-0.86-1.39l-0.24-0.24c-0.2,0.07-0.37,0.1-0.41,0.05c-0.05-0.05-0.02-0.21,0.06-0.4l-0.26-0.26l-1.37-0.86l0.41-0.41l1.87,0.34
      l0.16-0.32l1.97-1.97l-4.04-2.53l0.43-0.43l5.08,1.49l1.93-1.93c0.29-0.29,0.97-0.5,1.25-0.22
      C13.983,8.584,13.773,9.265,13.483,9.544z"/>
    <path d="M15.389,2.65h-1.6V0.5c0-0.28-0.23-0.5-0.5-0.5c-0.279,0-0.5,0.22-0.5,0.5v2.15H5.68V0.5
      c0-0.28-0.221-0.5-0.5-0.5c-0.28,0-0.5,0.22-0.5,0.5v2.15H3.159c-0.979,0-1.78,0.8-1.78,1.78v12.28c0,0.98,0.801,1.77,1.78,1.77
      h12.229c0.971,0,1.771-0.79,1.771-1.77V4.43C17.159,3.45,16.359,2.65,15.389,2.65z M16.34,16.71c0,0.53-0.431,0.96-0.951,0.96
      H3.159c-0.53,0-0.96-0.43-0.96-0.96V7.4H16.34V16.71z M16.34,5.97H2.199V4.43c0-0.53,0.43-0.96,0.96-0.96h12.229
      c0.521,0,0.951,0.43,0.951,0.96V5.97z"/>
  </svg>
</template>
